import { ESProduct, IProduct } from '@mybestbrands/types';
import { convertAdditionalImages } from '@/app/lib/converters/convertAdditionalImages';

const MD5 = require('md5.js');

export function createHash(image: string) {
  try {
    return new MD5().update(image).digest('hex');
  } catch (e) {
    //TODO dsantic 02.05.2024. log error
    // @ts-ignore
    // eslint-disable-next-line no-console
    console.log('ERROR', e.message);
    return null;
  }
}

type Coupon = {
  code: string;
  title: string;
  description: string;
  amount: number;
  amount_type: string;
  end_date_utc: string;
};

export const convertProduct = (product: ESProduct): IProduct => {
  const getHighestPriorityCoupon = (): Coupon | null => {
    if (product.discount_coupon) return product.discount_coupon;
    if (product.free_shipping_coupon) return product.free_shipping_coupon;
    if (product.new_customer_voucher) return product.new_customer_voucher;
    return null;
  };

  return {
    brandId: product.brand?.brand_id || null,
    brandName: product.brand?.brand_name || null,
    brandSlug: product.brand?.brand_url_name || null,
    breadcrumb: product.breadcrumb,
    categoryTagNames: product.category_tags,
    colors: product.colors,
    colorTags: product.color_tags,
    couponPrice: product.coupon_price,
    couponDiscount: product.coupon_discount,
    clickOutAllowed: product.clickout_allowed,
    cpc: product.click_costs,
    deepLink: product.deep_link,
    description: product.product_description ?? '',
    epc: product.marketing_epc,
    genders: product.gender_tags,
    groupId: product.group_id,
    hasCoupon: !!product?.available_coupon_types?.length,
    lowestPrice: product.lowest_price,
    mainImageUrl: createHash(product.image_url),
    additionalImages: convertAdditionalImages(product.additional_images),
    materials: product.materials || null,
    name: product.product_name,
    originalPrice: product.original_price,
    pageTags: product.page_tags,
    price: product.discounted_price,
    discountedPrice: product.discounted_price,
    productId: product.product_id,
    productLines: product.product_line_tags,
    randomHashDaily: product.random_hash_daily,
    retailerId: product.retailer.retailer_id,
    retailerName: product.retailer.retailer_name,
    retailerScore: product.retailer.retailer_score,
    retailerUrl: product.retailer.retailer_url_name,
    shippingCost: product.shipping_costs,
    shippingInfo: product.shipping_info,
    sizes: product.sizes.map((s) => ({ id: s, name: s })),
    priorityCoupon: getHighestPriorityCoupon(),
    discountCoupon: product.discount_coupon,
    freeShippingCoupon: product.free_shipping_coupon,
    newCustomerCoupon: product.new_customer_voucher,
    originalProductIds: product.original_product_ids,
    cssDeepLink: product.css_link,
  };
};
